import { MDBInput } from 'mdb-react-ui-kit' 
import React from 'react'

const BillingGroupAdmin = ({register, watch, errors, setValue}) => {
    return (
        <>
          <div className="mainText mt-3" id="general">
                Billing Group Admin Details   

            </div>

            <div className="add-numbermain">
                <div className="tel-numbers">Admin Name</div>
                <div className="d-flex w-30">
                    <div className="phoneselect w-100">
                        <MDBInput maxLength={50}
                         {...register('billing_admin_details.admin_name',{required :"Admin Name is required"})} />
                         {errors.billing_admin_details?.admin_name && (
                            <p className="text-danger">
                                {errors?.billing_admin_details?.admin_name.message}
                            </p>
                        )}
                    </div>
                </div>
            </div>


           
            <div className="add-numbermain">
                <div className="tel-numbers">To Email</div>
                <div className="d-flex w-30">
                    <div className="phoneselect w-100">
                        <MDBInput 
                        {...register('billing_admin_details.to_email', {
                            // required: "email is required", 
                        })} />
                        {errors.billing_admin_details?.to_email && (
                            <p className="text-danger">
                                {errors?.billing_admin_details?.to_email.message}
                            </p>
                        )}
                    </div>
                </div>
            </div>
            <div className="add-numbermain">
                <div className="tel-numbers">CC</div>
                <div className="d-flex w-30">
                    <div className="phoneselect w-100">
                        <MDBInput 
                        {...register('billing_admin_details.cc_email')}/>
                        {errors.billing_admin_details?.cc_email && (
                            <p className="text-danger">
                                {errors?.billing_admin_details?.cc_email.message}
                            </p>
                        )}
                    </div>
                </div>
            </div>
            <div className="add-numbermain">
                <div className="tel-numbers">BCC</div>
                <div className="d-flex w-30">
                    <div className="phoneselect w-100">
                        <MDBInput 
                        {...register('billing_admin_details.bcc_email')}/>
                        {errors.billing_admin_details?.bcc_email && (
                            <p className="text-danger">
                                {errors?.billing_admin_details?.bcc_email.message}
                            </p>
                        )}
                    </div>
                </div>
            </div>


        </>
    )
}

export default BillingGroupAdmin
